import { render, staticRenderFns } from "./FooterNavComponent.vue?vue&type=template&id=7f2d1102&scoped=true"
import script from "./FooterNavComponent.vue?vue&type=script&lang=js"
export * from "./FooterNavComponent.vue?vue&type=script&lang=js"
import style0 from "./FooterNavComponent.vue?vue&type=style&index=0&id=7f2d1102&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2d1102",
  null
  
)

export default component.exports